module.exports = __webpack_public_path__ + "img/tom-gillan.54df3e3c.jpg";